'use client'

import { ReactNode } from 'react'
// import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import {
  Box,
  // Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material'
import { useTranslations } from 'next-intl'
import { extractFullTextFromKeystoneDocument } from '@models'
import { Icon } from '@media-components'
import { AudioPlayer } from '@utils/audio-player'
import { STYLE_SIZE_CONSTANTS } from '@utils/styles'
import { ForceAny } from '@utils/typescript'
import { useArticleReadAloudStreaming } from './utilt'

export type ArticleReadAloudProps = {
  /** Stable id for this article (e.g. slug or pageUrl). Server caches audio by this id. */
  articleId: string
  /** Keystone document nodes (document field from DocumentRendererData). */
  document: ForceAny[]
  children?: ReactNode
}

export function ArticleReadAloud({
  articleId,
  document,
  children,
}: ArticleReadAloudProps) {
  const t = useTranslations('ResourceArticle.readAloud')
  const text = extractFullTextFromKeystoneDocument(document)
  const {
    audioSrc,
    isLoading,
    isBuffering,
    isBusy,
    error,
    handleListen,
    handleClose,
  } = useArticleReadAloudStreaming({
    articleId,
    text,
  })

  const trimmedText = text.trim()
  if (!trimmedText) {
    return null
  }

  if (audioSrc) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          position: 'sticky',
          top: -STYLE_SIZE_CONSTANTS.headerHeight,
          zIndex: 100,
        }}
      >
        {children}
        <AudioPlayer
          src={audioSrc}
          autoplay
          loading={isLoading}
          buffering={isBuffering}
          onClose={handleClose}
          minified={false}
        />
        {/* <audio src={audioSrc} autoPlay controls /> */}
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'start' }}>
      {children}
      <Tooltip
        title={
          <>
            {isLoading && t('loading')}
            {isBuffering && (
              <Typography component="span" variant="inherit">
                {t('buffering')}
              </Typography>
            )}
            {!isBusy && (error || t('start'))}
          </>
        }
      >
        <IconButton
          // className={CustomStylesClasses.outline}
          onClick={() => void handleListen()}
          // size="large"
          disabled={isBusy}
          mode="light"
          sx={{
            marginTop: '0.5rem',
          }}
        >
          {isBusy ? (
            <CircularProgress size={16} color="primary" />
          ) : (
            <Icon
              fontSize="large"
              iconName="Volume"
              colorValues="common.black"
            />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  )

  // return (
  //   <Button
  //     variant="outlined"
  //     size="small"
  //     onClick={() => void handleListen()}
  //     disabled={isBusy}
  //     color={error ? 'error' : 'primary'}
  //     startIcon={
  //       isBusy ? (
  //         <CircularProgress size={16} color="inherit" />
  //       ) : (
  //         <VolumeUpIcon fontSize="small" />
  //       )
  //     }
  //   >
  //     {isLoading && t('loading')}
  //     {isBuffering && (
  //       <Typography component="span" variant="inherit">
  //         {t('buffering')}
  //       </Typography>
  //     )}
  //     {!isBusy && (error || t('start'))}
  //   </Button>
  // )
}
